import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import WithdrawalRequestsListRequests from "./WithdrawalRequests";
import { Puff } from "react-loading-icons";
import NavBar from "../../../../components/NavBarAdmin";

const WithdrawalDetails = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    withdrawal: {},
    invoice_data: {},
  });

  const getWithdrawalDetails = async () => {
    setIsLoading(true);
    let info =
      await WithdrawalRequestsListRequests.getWithdrawalDetails(params);
    if (info && info.status) {
      setData(info.data);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getWithdrawalDetails();
  }, []);

  const handleChangesStatus = async (status) => {
    setIsLoading(true);
    let info = await WithdrawalRequestsListRequests.changeWithdrawalStatus({
      ...params,
      status: status,
    });
    if (info && info.status) {
      getWithdrawalDetails();
    }
    setIsLoading(false);
  };

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-xs-12 dashboard-content">
            <div className="row">
              <div className="col-8">
                <h2 className="dashboard-h2"> Withdrawal Detail</h2>
              </div>
            </div>
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-2 ">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Data Pedido
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.withdrawal.date_request}
                    ></input>
                  </div>
                  <div className="col-2 ">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Data Processado
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.withdrawal.date_process}
                    ></input>
                  </div>
                  <div className="col-2 ">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Data Pagamento
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.withdrawal.date_payment}
                    ></input>
                  </div>
                  <div className="col-2 ">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Valor levantamento
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.withdrawal.value}
                    ></input>
                  </div>
                  <div className="col-2 ">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      STATUS
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.withdrawal.status}
                    ></input>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-12">
                    <h3>Dados Faturação</h3>
                  </div>
                  <div className="col-2">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Nome
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.invoice_data.name}
                    ></input>
                  </div>
                  <div className="col-2">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      IBAN
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.invoice_data.iban}
                    ></input>
                  </div>
                  <div className="col-2">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Contribuinte
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.invoice_data.vat_number}
                    ></input>
                  </div>
                  <div className="col-2">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Morada
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.invoice_data.address}
                    ></input>
                  </div>
                  <div className="col-2">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Cidade
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.invoice_data.city}
                    ></input>
                  </div>
                  <div className="col-2">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Codigo Postal
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext text-light"
                      value={data.invoice_data.postal_code}
                    ></input>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-12">
                    <h3>Ações de estado</h3>
                  </div>
                  <div className="col">
                    <button
                      className="btn btn-warning me-3"
                      onClick={() => handleChangesStatus("PROCESS")}
                    >
                      Em processamento
                    </button>
                    <button
                      className="btn btn-success"
                      onClick={() => handleChangesStatus("FINISH")}
                    >
                      Transferencia Concluido
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default WithdrawalDetails;
